import React from 'react';
import { Building2, ClipboardList, TrendingUp } from 'lucide-react';
import { PARTIES_THEME } from './partiesTheme';
import MobileScrollTabs from '../shared/MobileScrollTabs';

const TABS = [
  { id: 'information', label: 'Directory', shortLabel: 'Directory', icon: Building2 },
  { id: 'outstandings', label: 'Outstandings', shortLabel: 'Due', icon: TrendingUp },
  { id: 'opening-balance', label: 'Opening balance', shortLabel: 'Opening', icon: ClipboardList },
];

export default function PartiesTabNav({ activeTab, onTabChange, className = '' }) {
  const theme = PARTIES_THEME;

  return (
    <nav
      className={`hidden md:flex w-full ${theme.tabNavBg} rounded-xl p-1.5 shadow-sm gap-1 ${className}`}
      aria-label="Parties sections"
    >
      {TABS.map(({ id, label, shortLabel, icon: Icon }) => {
        const isActive = activeTab === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => onTabChange(id)}
            className={`flex-1 min-w-0 inline-flex items-center justify-center gap-2 px-3 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
              isActive ? theme.tabActive : theme.tabIdle
            }`}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon className="h-4 w-4 shrink-0 opacity-80" aria-hidden />
            <span className="hidden sm:inline truncate">{label}</span>
            <span className="sm:hidden truncate">{shortLabel}</span>
          </button>
        );
      })}
    </nav>
  );
}

export function PartiesTabNavMobile({ activeTab, onTabChange, className = '' }) {
  const theme = PARTIES_THEME;
  return (
    <div className={`md:hidden ${className}`}>
      <MobileScrollTabs
        tabs={TABS}
        activeId={activeTab}
        onChange={onTabChange}
        ariaLabel="Parties section"
        navClassName={`${theme.tabNavBg} border border-teal-100/70 shadow-sm`}
        getButtonClassName={(_, isActive) =>
          isActive ? theme.tabActive : theme.tabIdle
        }
      />
    </div>
  );
}
